import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-shared-loan-meta-modal',
  templateUrl: './shared-loan-meta-modal.component.html',
  styles: [
    `
    .modal-container {
      height: 80vh; 
      overflow-y: auto; 
    }

    .modal-header {
      position: sticky;
      top: 0; /* Sticks to the top of its scrolling container */
      background: white; /* Add a background to prevent content from showing through */
      z-index: 10; 
      display: flex; 
      justify-content: space-between; 
      width: 100%; background-color: #f7f7f7; 
      margin-bottom: 1rem;
    }
    `
  ]
})
export class SharedLoanMetaModalComponent { 
  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    console.log(this.data,"loan meta modal");
  }
}
